import {Capitalize} from './capitalize'
import {Pesso} from './pesso'
import {PokemonBadge} from './pokemon-badge'

angular.module("app").filter('capitalize', () => new Capitalize());
angular.module('app').filter('filterPokemonBadge', () => new PokemonBadge());
angular.module('app').filter('pesso', () => new Pesso());
